import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFormValues, reset } from "redux-form";
import "react-toastify/dist/ReactToastify.css";
import "../MasterFormStyles.scss";
import "primeicons/primeicons.css";
import PropTypes from "prop-types";
import AddUpdateForm from "./AddUpdateForm";
import {
  addMasterData,
  updateMasterData,
  resetAddedData,
} from "../../../Store/Masters/MastersAction";
import {
  getAddedData,
  getShowAddedData,
} from "../../../Store/Masters/MastersSelectors";
import { FORM_MODE } from "../../../Shared/Constant/MasterFormConstants";
import UserRoles from "../../../Shared/Constant/UserRoles";
import { getAllDropdownOptionsData } from "../../../Store/Masters/DropdownMasters/DropdownMastersSelectors";
import {
  fetchStatesOptions,
  fetchDistrictsOptions,
  fetchPhcsOptions,
  fetchSubcentersOptions,
  fetchTalukasOptions,
  fetchAreaTypesOptions,
  fetchAreaCategoriesOptions,
  fetchTrainingOptions,
  fetchFacultyOptions,
  fetchProgramsOptions,
  fetchSchemesOptions,
  fetchRolesOptions,
  fetchVillagesOptions,
  resetDropdownOptions,
  fetchLgbOptions,
  fetchAccessLevelsOptions,
  fetchCorporationOptions,
} from "../../../Store/Masters/DropdownMasters/DropdownMastersAction";
import { WorkflowStatuses } from "../MasterUtils/MasterFormUtils";
import { validateReduxForm } from "../../../Shared/Component/Forms/MasterValidation";
import { useLanguage } from "../../ChangeLanguage/LanguageProvider";
import { useTranslation } from "react-i18next";
const MASTER_FORM_NAME = "masterAddUpdateForms";
const MasterAddUpdateForm = (props) => {
  const {
    mode,
    selectedItems,
    masterType,
    formConfig,
    enableFileDocument,
    onClose,
    initialTranslatedValue,
  } = props;
  // props.formConfig.initialValues
  const { t } = useTranslation("master");
  const { title, initialValues } = formConfig;
  const dispatch = useDispatch();
  const { selectedLanguageId } = useLanguage();
  const currentRole = sessionStorage.getItem("userRole");
  const showApproveRejectBtn =
    currentRole === UserRoles.SUPERADMIN &&
    selectedItems &&
    selectedItems.length > 0 &&
    selectedItems[0].status !== "Valid";

  const deleteApproveRejectBtn =
    currentRole === UserRoles.SUPERADMIN &&
    selectedItems &&
    selectedItems.length > 0 &&
    selectedItems[0].status === "Invalid" &&
    selectedItems[0].workflowStatus === WorkflowStatuses.DELETE_PENDING;

  const allOptionsData = useSelector(getAllDropdownOptionsData);
  console.log("allOptionsData",allOptionsData);
  
  const masterFormValues = useSelector((state) =>
    getFormValues(MASTER_FORM_NAME)(state)
  );
  const addedData = useSelector(getAddedData);
  const detailsShow = useSelector(getShowAddedData);

  const stateId =
    masterFormValues && masterFormValues.stateId ? masterFormValues.stateId : 1;

  const districtId =
    masterFormValues && masterFormValues.multidistrictId && masterFormValues.roleName === 'Multi District'
      ? []
      : masterFormValues && masterFormValues.districtId
      ? masterFormValues.districtId
      : 0;
  const corporationId =
    masterFormValues && masterFormValues.corporationId
        ? masterFormValues.corporationId
        : 0;

  const programId =
    masterFormValues && masterFormValues.programId
      ? masterFormValues.programId
      : 0;

  const talukaId =
    masterFormValues && masterFormValues.talukaId
      ? masterFormValues.talukaId
      : 0;

  const phcId =
    masterFormValues && masterFormValues.phcId ? masterFormValues.phcId : 0;

  const roleName =
  masterFormValues && masterFormValues.roleName ? masterFormValues.roleName : '';

  const subcenterId =
    masterFormValues && masterFormValues.subcenterId
      ? masterFormValues.subcenterId
      : 0;
    const lgbId =
    masterFormValues && masterFormValues.lgbId
      ? masterFormValues.lgbId
      : 0;

  const {
    districtOptionsData,
    isDistrictLoading,
    corporationOptionsData,
    isCorporationLoading,
    isPhcLoading,
    isProgramLoading,
    isSchemeLoading,
    isStateLoading,
    isSubcenterLoading,
    isTalukaLoading,
    phcOptionsData,
    programOptionsData,
    schemeOptionsData,
    stateOptionsData,
    trainingOptionsData,
    isTrainingLoading,
    facultyOptionsData,
    isFacultyLoading,
    subcenterOptionsData,
    talukaOptionsData,
    areaTypeOptionsData,
    areaCategoryOptionsData,
    isAreaTypeLoading,
    isAreaCategoryLoading,
    isRoleLoading,
    roleOptionsData,
    isVillageLoading,
    villageOptionsData,
    isLgbLoading,
    lgbOptionsData,
    accessLevelOptionsData,
    isAccessLevelLoading
  } = allOptionsData;
  const optionsData = {
    stateOptions: {
      isLoading: isStateLoading,
      options: stateOptionsData,
    },
    accessLevelOptions: {
      isLoading: isAccessLevelLoading,
      options: accessLevelOptionsData,
    },
    districtOptions: {
      isLoading: isDistrictLoading,
      options: districtOptionsData,
    },
    corporationOptions: {
      isLoading: isCorporationLoading,
      options: corporationOptionsData,
    },
    phcOptions: {
      isLoading: isPhcLoading,
      options: phcOptionsData,
    },
    programOptions: {
      isLoading: isProgramLoading,
      options: programOptionsData,
    },
    schemeOptions: {
      isLoading: isSchemeLoading,
      options: schemeOptionsData,
    },
    subcenterOptions: {
      isLoading: isSubcenterLoading,
      options: subcenterOptionsData,
    },
    talukaOptions: {
      isLoading: isTalukaLoading,
      options: talukaOptionsData,
    },
    trainingOptions: {
      isLoading: isTrainingLoading,
      options: trainingOptionsData,
    },

    facultyOptions: {
      isLoading: isFacultyLoading,
      options: facultyOptionsData,
    },

    mapMenusOptions: {
      isLoading: false,
      options: [
        { value: "IEC Module", label: "IEC Module" },
        { value: "Statemaster", label: "Statemaster" },
        { value: "Districtmaster", label: "Districtmaster" },
        { value: "Talukamaster", label: "Talukamaster" },
        { value: "Phcmaster", label: "Phcmaster" },
        { value: "Subcentermaster", label: "Subcentermaster" },
        { value: "Villagemaster", label: "Villagemaster" },
        { value: "Trainingcalendar", label: "Trainingcalendar" },
        { value: "localgoverningbodymaster", label: "localgoverningbodymaster" }
      ],
    },
    areaTypeOptions: {
      isLoading: isAreaTypeLoading,
      options: areaTypeOptionsData,
    },
    areaCategoryOptions: {
      isLoading: isAreaCategoryLoading,
      options: areaCategoryOptionsData,
    },
    roleOptions: {
      isLoading: isRoleLoading,
      options: roleOptionsData,
    },
    villageOptions: {
      isLoading: isVillageLoading,
      options: villageOptionsData,
    },
    lgbOptions: {
      isLoading: isLgbLoading,
      options: lgbOptionsData,
    },
  };
  useEffect(() => {
    // Dispatch action to reset dropdown options when mode changes to ADD
    dispatch(resetDropdownOptions());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(fetchRolesOptions(selectedLanguageId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLanguageId]);

  useEffect(() => {
    if (subcenterId && subcenterId > 0) {
      dispatch(fetchVillagesOptions(subcenterId, selectedLanguageId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subcenterId, selectedLanguageId]);

  useEffect(() => {
    dispatch(resetAddedData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(fetchStatesOptions(selectedLanguageId));
    // need to reset the dependents form fields
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [selectedLanguageId]);

  useEffect(() => {
    dispatch(fetchTrainingOptions(selectedLanguageId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLanguageId]);

  useEffect(() => {
    dispatch(fetchLgbOptions(selectedLanguageId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLanguageId]);

  useEffect(() => {
    dispatch(fetchFacultyOptions(selectedLanguageId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLanguageId]);

  useEffect(() => {
    dispatch(fetchAccessLevelsOptions(selectedLanguageId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLanguageId]);
  
  useEffect(() => {
    if(districtId && lgbId){
      dispatch(fetchCorporationOptions(selectedLanguageId, districtId, lgbId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLanguageId, districtId, lgbId]);

  useEffect(() => {
    dispatch(fetchProgramsOptions(selectedLanguageId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLanguageId]);

  useEffect(() => {
    if (programId && programId > 0) {
      dispatch(fetchSchemesOptions(programId, selectedLanguageId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [programId, selectedLanguageId]);

  useEffect(() => {
    if (stateId && stateId > 0) {
      dispatch(fetchDistrictsOptions(stateId, selectedLanguageId));
      // need to reset the dependents form fields
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateId, selectedLanguageId]);

  useEffect(() => {
    if (masterType === 'userMaster') {
      if (districtId && typeof districtId === 'number' && districtId > 0) {
        dispatch(fetchTalukasOptions(districtId, selectedLanguageId));
      } else if (districtId && Array.isArray(districtId) && districtId.length > 0) {
        dispatch(fetchTalukasOptions(districtId, selectedLanguageId));
      } else { }
    } else if (districtId && typeof districtId === 'number' && districtId > 0) {
      dispatch(fetchTalukasOptions(districtId, selectedLanguageId));
    } else { }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [districtId, selectedLanguageId]);

  useEffect(() => {
    if (corporationId && corporationId > 0) {
      dispatch(fetchTalukasOptions(corporationId, selectedLanguageId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [corporationId, selectedLanguageId]);

  useEffect(() => {
    if (districtId && districtId > 0) {
      if(masterType === 'subareaMaster' || masterType === 'userMaster' ){
        dispatch(fetchPhcsOptions(talukaId, selectedLanguageId, masterType, districtId, roleName, lgbId));
      }else if (talukaId && talukaId > 0){
        dispatch(fetchPhcsOptions(talukaId, selectedLanguageId, masterType, districtId, roleName, lgbId));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [talukaId, lgbId, selectedLanguageId, roleName,]);

  useEffect(() => {
    if (phcId && phcId > 0) {
      dispatch(fetchSubcentersOptions(phcId, selectedLanguageId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phcId, selectedLanguageId]);

  useEffect(() => {
    dispatch(fetchAreaTypesOptions(selectedLanguageId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLanguageId]);

  useEffect(() => {
    dispatch(fetchAreaCategoriesOptions(selectedLanguageId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLanguageId]);
  const multiUpdatedData = (values) => {
    return selectedItems.map((item) => {
      let updatedItem = { ...item };
      formConfig.fields.forEach((field) => {
        if (field.showWhenMultiUpdate) {
          updatedItem[field.name] = values[field.name];
          if (field.optionName) {
            updatedItem[field.optionName] = values[field.optionName];
          }
          if (field.translate) {
            updatedItem[field.name + "1"] = values[field.name + "1"];
          }
        }
      });
      return updatedItem;
    });
  };

  // const validateMasterForm = (values) => {
  //   let error = "";
  //   formConfig.fields.forEach((field) => {
  //     const fieldValue = values[field.name];
  //     let flag = true;

  //     if (field.whenVisible && field.whenVisible.length > 0) {
  //       field.whenVisible.forEach((element) => {
  //         const selectedValue = values[element.name];
  //         if (!element.values.includes(selectedValue)) {
  //           flag = false;
  //         }
  //       });
  //     }

  //     if (!flag) {
  //       return;
  //     }

  //     const validError = validateReduxForm(
  //       field.type,
  //       fieldValue,
  //       field.label,
  //       field.required,
  //       false,
  //       mode,
  //       masterType,
  //       values.roleName,
  //       values.talukaName
  //     );
  //     if (validError) {
  //       error = validError;
  //     }
  //   });

  //   return error;
  // };
const validateMasterForm = (values) => {
  let error = "";
  formConfig.fields.forEach((field) => {
    let flag = true;
    if (field.whenVisible && field.whenVisible.length > 0) {
      field.whenVisible.forEach((element) => {
        const selectedValue = values[element.name];
        if (!element.values.includes(selectedValue)) {
          flag = false;
        }
      });
    }
    if (
      field.name === "talukaId" &&
      values.roleName === "UPHC MO" &&
      values.lgbId !== 1
    ) {
      flag = false;
    }
    if (!flag) return;   // SKIP validation if not visible

    const validError = validateReduxForm(
      field.type,
      values[field.name],
      field.label,
      field.required,
      false,
      mode,
      masterType,
      values.roleName,
      values.talukaName
    );
    if (validError) {
      error = validError;
    }
  });
  return error;
};

  const onFormSubmit = (val) => {
    if (!validateMasterForm(val)) {
      if (mode === FORM_MODE.ADD) {
        dispatch(addMasterData(masterType, title, val, t, onClose));
      } else {
        let updatedFormData = val;
        if (selectedItems.length > 1) {
          updatedFormData = multiUpdatedData(val);
        }
        dispatch(
          updateMasterData(
            masterType,
            title,
            updatedFormData,
            onClose,
            true, 
            t
          )
        );
      }
      dispatch(reset(MASTER_FORM_NAME));
    }
  };

  const initialFormValues = getMasterFormInitialValues(
    initialValues,
    selectedItems,
    initialTranslatedValue
  );
  return (
    <AddUpdateForm
      form={MASTER_FORM_NAME}
      {...props}
      optionsData={optionsData}
      initialValues={initialFormValues}
      onSubmit={onFormSubmit}
      addedData={addedData}
      detailsShow={detailsShow}
      showApproveRejectBtn={showApproveRejectBtn}
      deleteApproveRejectBtn={deleteApproveRejectBtn}
      enableFileDocument={enableFileDocument}
    />
  );
};

export default MasterAddUpdateForm;
MasterAddUpdateForm.propTypes = {
  onClose: PropTypes.func.isRequired,
  mode: PropTypes.string.isRequired,
  selectedItems: PropTypes.array,
};

function getInitialAttachedDoc(selectedItems) {
  if (selectedItems && selectedItems.length > 1) {
    return selectedItems[0].attachedDoc;
  } else if (
    !selectedItems &&
    selectedItems.length === 0 &&
    !selectedItems[0].attachedDoc &&
    selectedItems[0].status === "Valid"
  ) {
    return "";
  }
  return selectedItems[0].attachedDoc;
}

function getMasterFormInitialValues(initialValues, selectedItems, initialTranslatedValue) {
  if (!selectedItems || selectedItems.length === 0) {
    return initialValues;
  }
  const selectedItem = selectedItems[0];
  const remarksInitialValue = selectedItem.remarks || "";
  const isDistrictObject =
    typeof selectedItem.districtId === "object" &&
    selectedItem.districtId !== null &&
    (Array.isArray(selectedItem.districtId)
      ? selectedItem.districtId.length > 0
      : Object.keys(selectedItem.districtId).length > 0);
  return {
    ...selectedItem,
    remarks: remarksInitialValue,
    ...(isDistrictObject
      ? { multidistrictId: selectedItem.districtId }
      : {}),
    attachedDoc: getInitialAttachedDoc(selectedItems),
    ...initialTranslatedValue,
  };
}
